import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';
import logo from '../assets/img/theme/tzone-logo-450x200.png';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useI18n, useTranslation } from '../i18n';
import API_BASE_URL from '../config/api';

const API_HOST = API_BASE_URL;



const Login = () => {
  const { t } = useTranslation();
  const { language, setLanguage } = useI18n();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const extractTokenFromResponse = (data) => {
    if (!data) return null;

    const direct =
      data.token ||
      data.accessToken ||
      data.jwt ||
      data?.data?.token ||
      data?.data?.accessToken ||
      null;

    if (direct && String(direct).trim()) return String(direct).trim();

    const nested =
      data?.user?.token ||
      data?.user?.accessToken ||
      data?.user?.jwt ||
      null;

    if (nested && String(nested).trim()) return String(nested).trim();

    return null;
  };

  const postLogin = async (path, payload) => {
    return axios.post(`${API_HOST}${path}`, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': language,
      },
      timeout: 20000,
      withCredentials: true,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    const selectedLanguage = language || 'es';

    const payload = {
      username: formData.username.trim(),
      password: formData.password,
      preferredLanguage: selectedLanguage,
    };

    try {
      let response;
      try {
        response = await postLogin('/api/auth/login', payload);
      } catch {
        response = await postLogin('/auth/login', payload);
      }

      const data = response?.data || {};
      const user = data.user;

      if (!user || !user.role) {
        setMessage(t('common.notFoundRole'));
        return;
      }

      localStorage.setItem('userId', user.id);
      localStorage.setItem('userRole', user.role);
      localStorage.setItem('userName', user.name || '');
      localStorage.setItem('userEmail', user.email || '');
      localStorage.setItem('labAccess', user.labAccess ? 'true' : 'false');

      // ✅ El idioma elegido en login tiene prioridad inmediata
      localStorage.setItem('language', selectedLanguage);
      setLanguage(selectedLanguage);

      const token = extractTokenFromResponse(data);
      if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('accessToken', token);
        localStorage.setItem('jwt', token);
        localStorage.setItem('sessionToken', token);
      }

      const params = new URLSearchParams(window.location.search);
      const redirect = params.get('redirect');

      let target = '/';
      if (redirect) {
        target = redirect;
      } else if (user.role === 'lab') {
        target = '/lab';
      } else if (user.role === 'superadmin') {
        target = '/superadmin';
      } else if (user.role === 'trainer') {
        target = '/trainer-dashboard';
      } else if (user.role === 'athlete') {
        target = '/athlete-dashboard';
      } else if (
        user.role === 'admin' ||
        user.role === 'moderator' ||
        user.role === 'trainer_admin'
      ) {
        target = '/admin/trainers';
      }

      window.location.href = target;
    } catch (error) {
      const serverMessage =
        error.response?.data?.error || error.response?.data?.message;

      if (serverMessage === 'Usuario bloqueado' || serverMessage === 'User blocked') {
        setMessage(t('login.blockedUser'));
      } else {
        setMessage(serverMessage || t('login.invalidCredentials'));
      }
    }
  };

  return (
    <div className="login-container">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <LanguageSwitcher dark />
      </div>

      <div className="login-logo">
        <img src={logo} alt="TZone Logo" />
      </div>

      <form className="login-form" onSubmit={handleSubmit}>
        <h2>{t('login.title')}</h2>

        <label>{t('common.username')}:</label>
        <input
          type="text"
          name="username"
          value={formData.username}
          onChange={handleChange}
          required
          autoComplete="username"
        />

        <label>{t('common.password')}:</label>
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          autoComplete="current-password"
        />

        <button type="submit">{t('common.login')}</button>

        {message && <p>{message}</p>}

        <p className="forgot-password">
          <a href="/forgot-password">{t('login.forgotPassword')}</a>
        </p>
      </form>
    </div>
  );
};

export default Login;